// Typelizer digest 6cfffa70baaca6104979ec526edb5118
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /rails/active_storage/blobs/proxy/:signed_id/*filename */
  show: (
    params: { signedId: string | number; filename: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/rails/active_storage/blobs/proxy/:signed_id/*filename', params, options),
    method: 'get',
  }),
}
